import axios from 'axios';

const updateSettings = params => axios.put('whatsapp/settings', params);

const acceptPolicy = () => axios.put('whatsapp/settings/accept');

export { updateSettings, acceptPolicy };
